import { Link } from 'react-router-dom'
import Cover from './Cover'
import Icon from './Icon'
import { formatDate } from '../lib/format'

/**
 * Article teaser.
 *
 * The whole card is clickable through a stretched overlay link, but the link
 * label is the article title - so the accessible name is the title, not
 * "Weiterlesen" six times over.
 */
export default function PostCard({ post }) {
  return (
    <article className="post-card">
      <Cover seed={post.slug} label={post.category} />

      <div className="post-card__body">
        <p className="post-card__meta">
          <time dateTime={post.date}>{formatDate(post.date)}</time>
          <span aria-hidden="true" />
          {post.minutes} Min. Lesezeit
        </p>

        <h3 className="post-card__title">
          <Link to={`/insights/${post.slug}`} className="card__link-overlay">
            <span className="sr-only">{post.title}</span>
          </Link>
          {post.title}
        </h3>

        <p className="post-card__excerpt">{post.excerpt}</p>

        <p className="post-card__more">
          <span className="link-cta" aria-hidden="true">
            Weiterlesen
            <Icon name="arrowRight" />
          </span>
        </p>
      </div>
    </article>
  )
}

/** Compact horizontal variant for the Insights sidebar. */
export function PostRow({ post }) {
  return (
    <Link to={`/insights/${post.slug}`} className="post-row">
      <Cover seed={post.slug} />
      <div>
        <span className="post-row__title">{post.title}</span>
        <span className="post-row__date">
          <time dateTime={post.date}>{formatDate(post.date)}</time>
        </span>
      </div>
    </Link>
  )
}
